import { FontAwesomeConfigurations } from '../Configuration/FontAwesomeConfiguration';
import './style.scss';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { motion, animate } from 'framer-motion';
import JUNOPushNotification, { JUNOPushNotificationProps } from '../../ui/components/JUNOPushNotification';
interface PushNotificationHandlerProps {}
const PushNotificationHandler: React.FC<PushNotificationHandlerProps> = () => {
  const [isShowing, setIsShowing] = useState(false);
  const [newNotifications, setNewNotifications] = useState<JUNOPushNotificationProps[]>([]);
  const [isExpanded, setIsExpanded] = useState(false && newNotifications.length == 1);
  const timerRef = useRef(0);
  const [dragStart, setDragStart] = useState(0);
  const [isDragged, setIsDragged] = useState(false); // is the past tense of drag 'dragged' or 'drug'?? i went with the more pc version...
  const [hasMultiple, setHasMultiple] = useState(false);
  const [x, setX] = useState(0);

  const clearNotis = () => {
    stopPushTimeout();
    setIsShowing(false);
    setIsExpanded(false);
    setHasMultiple(false);
    setNewNotifications([]);
  };

  const closeNoti = aNotiId => {
    setNewNotifications(current => {
      return current.filter(noti => {
        return noti.params.id != aNotiId;
      });
    });
    if (newNotifications.length == 1) {
      // newNotifications.length doesnt change until next render so if we only have the 1 it will be the one getting removed
      clearNotis();
    }
  };

  const markNotiAsRead = (message, aNotiId) => {
    const { type } = message;
    if (type != PubNubPayload.TYPE_TEXT && type != PubNubPayload.TYPE_CHATREQUEST) {
      App.INSTANCE.mApi.Request(
        'custom_api/api_Services_Notifications.php',
        {
          api: 'api_mark_notifications_read',
          notifications: [aNotiId],
        },
        () => {
          // just decrement the notification count on success
          PubNubCenter.INSTANCE?.dispatch(PubNubCenter.ON_SOCIAL_NOTIFICATION_READ, this, {
            channel: App.INSTANCE.CurrentUser.ChatRoom,
          });
        },
        error => {
          console.error(error);
        },
      );
    }
  };

  const clickNoti = (aNotiId, aNotiUrl, message) => {
    const { type } = message;
    if (App.INSTANCE.mCommsPanel && type == PubNubPayload.TYPE_TEXT) {
      return;
    }

    App.INSTANCE.route(aNotiUrl);
    markNotiAsRead(message, aNotiId);
  };

  /*
  const onNotiSwipe = (currentPoint, notification, clear = false) => {
    const diff = Math.abs(currentPoint - dragStart);
    if (diff > 100) {
      if (clear) {
        clearNotis();
      } else {
        if (isExpanded) {
          markNotiAsRead(notification.message, notification.params.id);
          closeNoti(notification.params.id);
        } else {
          clearNotis();
        }
      }
    }
  };
  */

  const onNotiSwipe = (currentPoint, notification, clear = false) => {
    //pos means read
    const diff = currentPoint - dragStart;
    if (Math.abs(diff) > 100) {
      if (diff < 0) {
        clearNotis();
      } else {
        markNotiAsRead(notification.message, notification.params.id);
        closeNoti(notification.params.id);
      }
    }
  };

  // when i get a noti, start the timer
  // if i click expand, stop the timer,
  // if i click collapse, start the timer
  // if i click close, stop the timer
  // if i'm collapsed and i get a new noti, restart the timer
  const startPushTimeout = () => {
    timerRef.current = setTimeout(() => {
      clearNotis();
    }, CrowdHub_App.CONFIG.WEB_PUSH_NOTIFICATION_DISPLAY_TIME);
  };

  const stopPushTimeout = () => {
    clearTimeout(timerRef.current);
  };

  const onCloseNotification = useCallback(
    notiId => {
      closeNoti(notiId);
    },
    [isExpanded],
  );

  const onClickNotification = (notiId, url, message) => {
    if (isExpanded || newNotifications.length == 1) {
      clickNoti(notiId, url, message);
      closeNoti(notiId);
      setIsExpanded(false);
      startPushTimeout();
    } else {
      if (!isDragged) {
        stopPushTimeout();
        setIsExpanded(true);
        setHasMultiple(true);
      }
    }
  };

  const pushNotifications = (message, url: string, title: string, image?: string, icon?: string) => {
    let notiId = Date.now();
    let newNoti = {
      message: message,
      params: {
        id: notiId,
        image: image,
        icon: icon,
        url: url,
        title: title,
      },
      onClickNotification: onClickNotification,
      onCloseNotification: onCloseNotification,
    };
    setIsShowing(true);
    setNewNotifications([...newNotifications, newNoti]);

    stopPushTimeout();
    startPushTimeout();
  };

  useEffect(() => {
    // Clear the timeout when the component unmounts
    return () => clearTimeout(timerRef.current);
  }, []);

  // this is messy looking but we're just adding a bunch of event listeners and removing on unmount
  useEffect(() => {
    addisteners(pushNotifications);

    return () => {
      PubNubCenter.INSTANCE.removeEventListenerByScope(PubNubCenter.ON_SNOOZE_NOTIFICATIONS, this);
      PubNubCenter.INSTANCE.removeEventListenerByScope(PubNubCenter.ON_UNSNOOZE_NOTIFICATIONS, this);
      PubNubCenter.INSTANCE.removeEventListenerByScope(PubNubCenter.ON_MESSAGE, this);
      PubNubCenter.INSTANCE.removeEventListenerByScope(PubNubCenter.ON_REQUEST, this);
      PubNubCenter.INSTANCE.removeEventListenerByScope(PubNubCenter.ON_SOCIAL_NOTIFICATION, this);
      PubNubCenter.INSTANCE.removeEventListenerByScope(PubNubCenter.ON_EXTERNAL_URL, this);
      // PubNubCenter.INSTANCE?.unsubscribeToRoom(PubNubCenter.CHANNEL_TYPE_NOTIFICATION);
    };
  }, [newNotifications]);

  // empty notis
  if (newNotifications.length == 0) {
    return <></>;
  }

  // single noti
  if (newNotifications.length == 1 && !hasMultiple) {
    return (
      <div className={`push_noti_handler ${(isShowing && 'visible') || ''} expanded`}>
        <div className={`push_noti_handler_container visible`}>
          {
            <SingleNotificationContainer
              notification={newNotifications[0]}
              onDragStart={(event, info) => setDragStart(info.point.x)}
              onDragEnd={(event, info) => {
                onNotiSwipe(info.point.x, newNotifications[0]);
              }}
              onClickNotification={onClickNotification}
              onCloseNotification={onCloseNotification}
            />
          }
        </div>
      </div>
    );
  }

  // multiple notis
  return (
    <>
      <motion.div
        className={`push_noti_handler multi ${(isShowing && newNotifications.length > 0 && 'visible') || ''} ${
          isExpanded && 'expanded'
        } ${isDragged && 'dragged'}`}
        drag={isExpanded ? false : 'x'}
        dragConstraints={{ top: 0, bottom: 0, right: 0, left: -75 }}
        dragTransition={{ bounceStiffness: 600, bounceDamping: 50, power: 0, min: 0, max: 200, timeConstant: 250 }}
        dragElastic={0.1}
        whileTap={{ cursor: 'grabbing' }}
        dragDirectionLock
        dragSnapToOrigin={false}
        animate={{ x }}
        onDragStart={(event, info) => {
          setDragStart(info.point.x);
        }}
        onDragEnd={(event, info) => {
          const draggedLeft = dragStart > info.point.x;
          if (draggedLeft) {
            setX(-75);
            setIsDragged(true);
            stopPushTimeout();
            setTimeout(() => {
              setIsDragged(false);
              setX(0);
              startPushTimeout();
            }, 3000);
          } else {
            setIsDragged(false);
          }
        }}
      >
        <div className={`push_noti_hoverable ${isExpanded ? 'visible' : ''}`}>
          <div
            className="expand"
            onClick={() => {
              if (!isDragged) {
                setIsExpanded(old => !old);
                // we have to reverse logic here since isExpanded doesnt change until next render
                if (!isExpanded) {
                  stopPushTimeout();
                  setHasMultiple(true);
                } else {
                  startPushTimeout();
                  setHasMultiple(false);
                }
              }
            }}
          >
            {isExpanded ? <span>Collapse</span> : <span>Expand</span>}
            <span className={`expand_icon ${isExpanded ? 'expanded' : ''}`}>
              <i className={`up ${FontAwesomeConfigurations.ICON_CHEVRON_UP}`}></i>
              <i className={`down ${FontAwesomeConfigurations.ICON_CHEVRON_DOWN}`}></i>
            </span>
          </div>
          <div className="close" onClick={clearNotis}>
            <i className={FontAwesomeConfigurations.ICON_XMARK}></i>
          </div>
        </div>
        {isExpanded
          ? ExpandedNotiContainer({
              newNotifications,
              setDragStart,
              onNotiSwipe,
              onClickNotification,
              onCloseNotification,
            })
          : CollapsedNotiContainer({
              newNotifications,
              onClickNotification,
              onCloseNotification,
            })}
      </motion.div>
      {isShowing && !isExpanded && App.INSTANCE.isPhone() && (
        <span
          className={`noti_handler_close right ${isShowing ? 'visible' : ''}`}
          onClick={() => {
            setIsDragged(false);
            setDragStart(0);
            setX(0);
            clearNotis();
          }}
        >
          Close All
        </span>
      )}
    </>
  );
};

function SingleNotificationContainer({
  notification,
  onDragStart,
  onDragEnd,
  onClickNotification,
  onCloseNotification,
}) {
  return (
    <div className="push_noti_container_behind" key={`push_noti_${notification.params.id}`}>
      {App.INSTANCE.isPhone() ? (
        <>
          <span>Read</span>
          <motion.div
            className="push_noti_container"
            key={`push_noti_${notification.params.id}`}
            drag="x"
            dragConstraints={{ top: 0, bottom: 0 }}
            dragTransition={{ bounceStiffness: 600, bounceDamping: 20 }}
            dragElastic={0.5}
            whileTap={{ cursor: 'grabbing' }}
            dragDirectionLock
            dragSnapToOrigin={true}
            onDirectionLock={axis => console.log(axis)}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
          >
            <JUNOPushNotification
              message={notification.message}
              params={notification.params}
              onClickNotification={onClickNotification}
              onCloseNotification={onCloseNotification}
            />
          </motion.div>
          <span className="right">Close</span>
        </>
      ) : (
        <motion.div whileHover={{ scale: 1.1 }} className="push_noti_container expanded">
          <JUNOPushNotification
            message={notification.message}
            params={notification.params}
            onClickNotification={onClickNotification}
            onCloseNotification={onCloseNotification}
          />
        </motion.div>
      )}
    </div>
  );
}

function ExpandedNotiContainer({
  newNotifications,
  setDragStart,
  onNotiSwipe,
  onClickNotification,
  onCloseNotification,
}) {
  return (
    <div className={`push_noti_handler_container visible`}>
      {newNotifications.map((notification, index) => {
        return (
          <SingleNotificationContainer
            key={`noti_container_${index}`}
            notification={notification}
            onDragStart={(event, info) => setDragStart(info.point.x)}
            onDragEnd={(event, info) => {
              onNotiSwipe(info.point.x, notification);
            }}
            onClickNotification={onClickNotification}
            onCloseNotification={onCloseNotification}
          />
        );
      })}
    </div>
  );
}

function CollapsedNotiContainer({ newNotifications, onClickNotification, onCloseNotification }) {
  return (
    <>
      <div className={`push_noti_handler_container`}>
        <div className="push_noti_container_behind_collapsed">
          {newNotifications.map(notification => {
            return (
              <div className="push_noti_container_behind" key={`push_noti_${notification.params.id}`}>
                <div className="push_noti_container">
                  <JUNOPushNotification
                    message={notification.message}
                    params={notification.params}
                    onClickNotification={onClickNotification}
                    onCloseNotification={onCloseNotification}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
export default PushNotificationHandler;

function addisteners(pushNotifications) {
  // TODO snoozing is future
  // PubNubCenter.INSTANCE?.addEventListener(
  //   PubNubCenter.ON_SNOOZE_NOTIFICATIONS,
  //   (event, message) => {
  //     if (PushNotificationHandler.SNOOZE_TIMER) {
  //       clearTimeout(PushNotificationHandler.SNOOZE_TIMER);
  //     }
  //     PushNotificationHandler.SNOOZE_TIMER = setTimeout(() => {
  //       PushNotificationHandler.USER_SNOOZED_NOTIFICATIONS = false;
  //     }, message.snooze_time);
  //     PushNotificationHandler.USER_SNOOZED_NOTIFICATIONS = true;
  //   },
  //   this,
  // );
  // PubNubCenter.INSTANCE?.addEventListener(
  //   PubNubCenter.ON_UNSNOOZE_NOTIFICATIONS,
  //   (event, message) => {
  //     if (PushNotificationHandler.SNOOZE_TIMER) {
  //       clearTimeout(PushNotificationHandler.SNOOZE_TIMER);
  //     }
  //     PushNotificationHandler.USER_SNOOZED_NOTIFICATIONS = false;
  //   },
  //   this,
  // );

  //only show download in the dropdown/toast/browser notification if we're on the web and not mobile
  if (!App.CORDOVA) {
    PubNubCenter.INSTANCE?.addEventListener(
      PubNubCenter.ON_EXTERNAL_URL,
      (event, message) => {
        const { url, content_name } = message.message;
        let title = `<b>${content_name}</b> download is ready!`;
        pushNotifications(message, url, title, '', FontAwesomeConfigurations.ICON_ARROW_DOWN_TO_BRACKET);
      },
      this,
    );
  }
  PubNubCenter.INSTANCE?.addEventListener(
    PubNubCenter.ON_MESSAGE,
    (event, message) => {
      const { user, type, channel } = message;
      const { channelType } = message.message;
      // we dont want to message ourselves
      if (user?.user_id == App.INSTANCE.CurrentUser.Id) {
        return;
      }

      if (App.INSTANCE.inLiveSession()) {
        return; //don't show brower notifications while in alive session
      }

      if (type == PubNubPayload.TYPE_TEXT && channelType == 'DM') {
        // check if we want a notification
        if (App.INSTANCE.CurrentUser.shouldNotifyUserByType(CrowdHub_App.NOTIFICATION_PREF_TYPE_DM, 'web_push')) {
          if (App.INSTANCE.mCommsPanel) {
            return;
          }
          let convoMessage = App.INSTANCE.CurrentUser.Conversations?.filter(convo => {
            return convo.Room == channel;
          });
          let url = App.INSTANCE.appRouter.generate('navigate.messagesmodule', {
            tab: 'chat',
            conversation: convoMessage[0]?.Id ?? -1,
          });
          let image = user?.avatar != null ? user?.avatar : user?.user_avatar;
          let title = `<b>Direct message</b> from <b>${user?.user_firstname} ${user?.user_lastname}</b>`;
          pushNotifications(message, url, title, image);
        }
      }
    },
    this,
  );
  PubNubCenter.INSTANCE?.addEventListener(
    PubNubCenter.ON_REQUEST,
    (event, message) => {
      const { user, type, conversation } = message;
      const { conversation_id } = message.message;
      // we dont want to message ourselves
      if (user?.user_id == App.INSTANCE.CurrentUser.Id) {
        return;
      }
      if (type == PubNubPayload.TYPE_CHATREQUEST) {
        if (conversation_id) {
          App.INSTANCE.CurrentUser?.receiveRestartOldConversation(conversation_id, conversation?.state);
        } else {
          App.INSTANCE.CurrentUser?.addRawConversation(conversation);
        }

        if (App.INSTANCE.inLiveSession()) {
          return; //don't show brower notifications while in alive session
        }

        // check if we want a notification
        if (
          App.INSTANCE.CurrentUser.shouldNotifyUserByType(CrowdHub_App.NOTIFICATION_PREF_TYPE_DM_REQUEST, 'web_push')
        ) {
          let url = App.INSTANCE.appRouter.generate('navigate.messagesmodule', {
            tab: 'chat',
            conversation: conversation_id,
          });
          let image = user?.avatar != null ? user?.avatar : user?.user_avatar;
          let title = `<b>Direct message request</b> from <b>${user?.user_firstname} ${user?.user_lastname}</b>`;
          pushNotifications(message, url, title, image);
        }
      }
    },
    this,
  );
  PubNubCenter.INSTANCE?.addEventListener(
    PubNubCenter.ON_SOCIAL_NOTIFICATION,
    (event, message) => {
      const { user } = message;
      const {
        content_id,
        thread_id,
        parent_id,
        content_name,
        content_type,
        parent_name,
        notifiee_id,
        notifier_name,
        notifiee_title,
      } = message.message;
      if (notifiee_id != App.INSTANCE.CurrentUser.Id) {
        return;
      }
      // we dont need a push notification if we are on the notification panel
      if (App.INSTANCE.appRouter.lastRouteResolvedUrl() == App.INSTANCE.appRouter.generate('navigate.notifications')) {
        return;
      }

      if (App.INSTANCE.inLiveSession()) {
        return; //don't show brower notifications while in alive session
      }

      let shouldPush = false;
      let notiTitle = `<span class='ui_double_line'><b>${notifier_name}</b> ${notifiee_title} <b>${content_name}</b>`;
      let notiImage = user?.avatar != null ? user?.avatar : user?.user_avatar;
      let notiIcon;
      let url;
      switch (content_type) {
        // Feed
        case CrowdHub_App.NOTIFICATION_TYPE_FEED_TAG:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_TAGGED,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.grouppost', {
            feed_id: `${content_id}`,
          });
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FEED_LIKE:
        case CrowdHub_App.NOTIFICATION_TYPE_FEED_COMMENT_LIKE:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_LIKES,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.grouppost', {
            feed_id: `${content_id}`,
          });
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FEED_COMMENT:
        case CrowdHub_App.NOTIFICATION_TYPE_FEED_REPLY:
        case CrowdHub_App.NOTIFICATION_TYPE_FEED_COMMENT_REPLY:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_RESPONSES,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.grouppost', {
            feed_id: `${content_id}`,
          });
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FEED_NEW_POST:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_FEED_ACTIVITY,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.grouppost', {
            feed_id: `${content_id}`,
          });
          message.message.content_name = parent_name;
          break;
        // Forum
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_TAG: // we want the title to be the forum title
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_TAGGED,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.forumpost', {
            feed_id: `${parent_id}`,
            parent_id: `${content_id}`,
          });
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_LIKE:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_LIKES,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.forumpost', {
            feed_id: `${parent_id}`,
            parent_id: `${content_id}`,
          });
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_COMMENT_LIKE:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_LIKES,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.forumpost', {
            parent_id: `${parent_id}`,
            feed_id: `${content_id}`,
          });
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_COMMENT:
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_REPLY:
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_COMMENT_REPLY:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_RESPONSES,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.forumpost', {
            parent_id: `${parent_id}`,
            feed_id: `${content_id}`,
          });
          url += `?thread_id=${thread_id}`;
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_NEW_POST:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_FORUM_ACTIVITY,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.forumpost', {
            feed_id: `${parent_id}`,
            parent_id: `${content_id}`,
          });
          break;
        case CrowdHub_App.NOTIFICATION_TYPE_FORUM_NEW_TOPIC:
          shouldPush = App.INSTANCE.CurrentUser.shouldNotifyUserByType(
            CrowdHub_App.NOTIFICATION_PREF_TYPE_FORUM_TOPIC,
            'web_push',
          );
          url = App.INSTANCE.appRouter.generate('navigate.connect.forumtopic', {
            parent_id: content_id,
          });
          notiTitle = `<b>New forum topic!</b><br/><span class='ui_single_line'>${content_name}</span>`;
          notiIcon = FontAwesomeConfigurations.ICON_BULLHORN_SOLID;
          break;
      }

      //create a list of notification types that shouldn't show dropdown/toast/browser notification on mobile
      let mobileSupressTypes = [
        CrowdHub_App.NOTIFICATION_TYPE_LMS_USER_ENROLLED,
        CrowdHub_App.NOTIFICATION_TYPE_LMS_USER_WAITLISTED,
        CrowdHub_App.NOTIFICATION_TYPE_FORUM_NEW_TOPIC,
      ];

      let supressForMobile = App.CORDOVA && mobileSupressTypes.indexOf(content_type) >= 0;

      if (shouldPush && !supressForMobile) {
        pushNotifications(message, url, notiTitle, notiImage, notiIcon);
      }
    },
    this,
  );

  //this is just the channel "NOTIFICATION" which would span all juno clients and was super noisy.
  //dom and I couldn't figure out where it'd be used so we're not
  //PubNubCenter.INSTANCE?.subscribeToRoom(PubNubCenter.CHANNEL_TYPE_NOTIFICATION, true);
}
